import React from 'react'
import {
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Select,
  MenuItem
} from '@mui/material'
import theme from '../theme'

interface Props {
  maxDuration: number
  mediaType: 'image' | 'video'
  onMediaTypeChange: (mediaType: 'image' | 'video') => void
  selectedDuration: number
  setSelectedDuration: (duration: number) => void
}

const CreativeTypeSelector = ({
  maxDuration,
  mediaType,
  onMediaTypeChange,
  selectedDuration,
  setSelectedDuration
}: Props) => {
  const maxDurationSeconds = maxDuration ? Math.floor(maxDuration / 1000) : 0
  const durationList = Array.from(
    { length: maxDurationSeconds + 1 },
    (_, index) => index
  ).slice(6)

  const formatSecondsDuration = (seconds: number): string => {
    return seconds.toString().padStart(2, '0')
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginBottom: theme.space['24']
      }}
    >
      <FormControl>
        <RadioGroup sx={{ flexDirection: 'row' }}>
          <FormControlLabel
            value="video"
            control={<Radio />}
            label="Video"
            checked={mediaType === 'video'}
            onChange={() => onMediaTypeChange('video')}
          />
          <FormControlLabel
            value="image"
            control={<Radio />}
            label="Image"
            checked={mediaType === 'image'}
            onChange={() => onMediaTypeChange('image')}
          />
        </RadioGroup>
      </FormControl>
      {mediaType === 'image' && (
        <Select
          sx={{
            height: '36px',
            width: '95px',
            marginBottom: theme.space['4']
          }}
          value={selectedDuration || 15}
          onChange={(e) => {
            setSelectedDuration(Number(e.target.value))
          }}
        >
          {durationList.map((duration) => (
            <MenuItem
              key={duration}
              value={duration}
              sx={{ textAlign: 'center' }}
            >
              00:{formatSecondsDuration(duration || 0)}
            </MenuItem>
          ))}
        </Select>
      )}
    </Box>
  )
}

export default CreativeTypeSelector
